import React from 'react';
// LIBRARIES
import cx from 'classnames';
//COMPONENTS
// STYLES
import './style.scss';
import FlexBox from '../FlexBox';
import postPeFailed from '../../../assets/images/failed.svg';
//ASSETS

class InputPostPe extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
		};
	}

	render() {
		const { props, state } = this;
		const {
			inputContainerClassName,
			type,
			inputRef,
			readOnly,
			inputClassName,
			isValid,
			placeholder,
			showError,
			errorMsg,
			inputImg,
			cardIconId,
			UIType,
			...others
		} = props;

		return (
			<div
				className={cx(
					UIType === '12pc'
						? 'input-12pc-container'
						: UIType === 'postpe'
						? 'input-postpe-container'
						: 'input-merchant-container',
					inputContainerClassName,
				)}>
				<div className="flex">
					<input
						id={cardIconId || 'inputPostpe'}
						{...others}
						ref={inputRef}
						style={readOnly ? { pointerEvents: 'none' } : {}}
						type={type}
						readOnly={readOnly}
						className={cx(
							'input__element fs-14 font-medium-postpe bg-gray full-border br-7 pd-10 w-100',
							{
								'input__element--valid': isValid && isValid !== null,
								'input__element--invalid': isValid === false || showError === true,
							},
							inputClassName,
						)}
						placeholder={placeholder}
					/>
					{inputImg && <img src={inputImg} className="w-5 mr-r-10" />}
				</div>
				{showError && (
					<FlexBox alignCenter flexBoxClass="input--error up-to-down-scale clr-red animated fadeInDown pt2 br-9">
						<img src={postPeFailed} style={{ width: '14px' }} className="mr1" />
						<p className="fs-14 lh-16">{errorMsg}</p>
					</FlexBox>
				)}
			</div>
		);
	}
}
export default InputPostPe;
